import Cookies from 'cookies-js';
import { stringify } from 'qs';
// eslint-disable-next-line no-shadow
import fetch from 'unfetch';
import httpStatus from 'http-status';

function createUpdateDeleteMethods(method) {
  const methods = /^(DELETE|PATCH|POST|PUT)$/iu;

  return methods.test(method);
}

function encodePayload(contentType, payload) {
  if (contentType === 'application/json') {
    return JSON.stringify(payload);
  }

  if (contentType === 'application/x-www-form-urlencoded') {
    return stringify(payload);
  }

  return payload;
}

function decodeResponse(contentType, response) {
  if (contentType === 'application/json') {
    // Fall back to an empty string if the response is empty. This prevents some issues with
    // Safari and "204 No Content" responses.
    return response.text().then(content => (content ? JSON.parse(content) : ''));
  }

  return response.text();
}

function generateStatus(statusCode) {
  return `${statusCode} ${httpStatus[statusCode]}`;
}

function generateError(statusCode, error) {
  const errorMessage = error || httpStatus[`${statusCode}_MESSAGE`];
  const errorName = generateStatus(statusCode);
  const generatedError = new Error();

  generatedError.message = errorMessage;
  generatedError.name = errorName;

  return generatedError;
}

export function fetchWrapper(options) {
  const {
    authToken,
    contentType = 'application/json',
    crossOrigin,
    credentials = crossOrigin ? 'include' : 'same-origin',
    errorCallback,
    headers = {},
    mode = crossOrigin ? 'cors' : 'same-origin',
    payload,
    successCallback,
    sendAuthToken,
    unauthorisedCallback,
    url
  } = options;
  // Uppercase this because some methods aren't allowed in lowercase, e.g. `patch`.
  const method = options.method.toUpperCase();

  if (createUpdateDeleteMethods(method)) {
    headers['Content-Type'] = contentType;

    if (!headers['X-CSRFToken']) {
      headers['X-CSRFToken'] = Cookies.get('csrftoken');
    }
  }

  if (sendAuthToken) {
    headers.Authorization = `Bearer ${authToken || Cookies.get('token')}`;
  }

  return fetch(url, {
    body: encodePayload(contentType, payload),
    credentials,
    headers,
    method,
    mode
  })
    .then(response => {
      if (response.ok) {
        return decodeResponse(contentType, response);
      }

      if (response.status === 400) {
        return decodeResponse(contentType, response).then(error => Promise.reject(error));
      }

      if (response.status === 403) {
        return decodeResponse(contentType, response).then(error =>
          Promise.reject(generateError(response.status, error))
        );
      }

      throw generateError(response.status);
    })
    .then(successCallback)
    .catch(error => {
      if (error.name === generateStatus(403) && unauthorisedCallback) {
        unauthorisedCallback(error);
      } else if (errorCallback) {
        errorCallback(error);
      } else {
        throw error;
      }
    });
}
